import React, { useEffect, useContext, useState, useMemo } from 'react';
import LazyLoaderWrapper from 'atoms/LazyLoaderWrapper';
import { useSelector, useDispatch } from 'react-redux';
import ProductSummary from './ReusableComponents/ProductSummary';
import ProductDescription from './ReusableComponents/ProductDescription';
import { fetchMenuAction } from '@kfc-global/react-shared/redux/Actions/MenuAction';
import {
  isEmptyObject,
  getTernaryValue,
  getLength,
  getAndCheck,
  getValueOrDefaultObject,
  getBackgroundImagePath,
  getMainImagePath,
  getPrice,
  getUserType,
  getFirstArrayItem,
  getBackgroundImageSrc,
  isCateringDisposition,
  calculatePrice,
  getCouponDetails,
  createNewBasketId,
  isDeliveryDisposition,
  isPickupDisposition,
  getCheckIfAnyOnePass,
  goToMenuPage,
} from 'common/utilities/utils';
import { UserOrderContext } from 'context/context';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/AU/Constants/MenuPDPPageConstants';
import ImageComponent from 'atoms/Image';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import RecommendedContainer from 'organisms/RecommendedComponent/AU/Container/RecommendedContainer';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
import RemoveGiftCardModal from 'organisms/CartPage/AU/Presentation/ReusableComponents/RemoveGiftCardModal';
import {
  createPDPPayload,
  getFinalPayload,
  breadcrumbtemplate,
  checkForQuantityLimit,
  RecommendedAnalyticHandler,
  setPDPDataHandler,
  checkIfProdQtyUpdate,
  checkIfItemUpdated,
  getQuantity,
  removePromoTag,
  getNameAndRecommendationType,
} from 'organisms/MenuPDPPage/AU/Utilities/MenuPDPUtils';
import {
  addItemToCartAction,
  updateLineitemAction,
  applyCoupon,
} from '@kfc-global/react-shared/redux/Actions/CartAction';
import {
  ROUTE_URL,
  SOURCE_FLAG_MOBILE,
  ANALYTICS_SHARED_CONSTANTS,
  LOCAL_STORAGE_KEYS,
  SESSION_STORAGE_KEYS,
} from 'common/constants/SharedConstants';
import LegalInformationDescription from 'organisms/MenuPDPPage/AU/Presentation/ReusableComponents/LegalInformationDescription';
import { useHistory } from 'react-router-dom';
import { checkIfCateringPage } from 'common/utilities/CateringPLPUtils';

import IndulgentAddOn from 'organisms/CartPage/AU/Presentation/ReusableComponents/IndulgentAddOn';
import { useAppDispatch } from '@kfc-global/react-shared/redux/Store/hooks';
import { setPWAstorage } from '@kfc-global/react-shared/redux/Slices/PwaStorageSlice';

export const removeCouponHandler = ({ setCouponModal, parms, setAddToClickParms }) => {
  setCouponModal(true);
  setAddToClickParms(parms);
};
/* method to segregate recommended data & make it a combo data */
export const getComboAndRecommendationDataSopac = (recommendationRules, UPSELL, CROSSELL, ADDONS) => {
  let data = {
    combo: [],
    recommendation: [],
    addOnRecommendedItems: [],
    ruleName: {},
  };
  if (getLength(recommendationRules)) {
    let combo = recommendationRules.find(({ recommendationType }) => recommendationType === UPSELL);
    let recommendation = recommendationRules.find(({ recommendationType }) => recommendationType === CROSSELL);
    data.combo = getTernaryValue(isEmptyObject(combo), combo?.recommendedItems, []);
    data.recommendation = getTernaryValue(isEmptyObject(recommendation), recommendation?.recommendedItems, []);
    let addOnRecommendation = recommendationRules.find(({ recommendationType }) => recommendationType === ADDONS);
    data.ruleName = getNameAndRecommendationType(addOnRecommendation);
    data.addOnRecommendedItems = getTernaryValue(
      isEmptyObject(addOnRecommendation),
      addOnRecommendation?.recommendedItems,
      [],
    );
  }
  return data;
};
/* method to return pdpProductImage html */
export const pdpProductImageSopac = (pdpData, isMobile, imageContainerSize, isPdpDataLoading) => {
  const { PDP_PRODUCT_MOBILE_IMG, PDP_PRODUCT_IMG } = MENU_PDP_PAGE_CONSTANTS;
  const imagePath = getMainImagePath(
    pdpData?.content,
    imageContainerSize.containerWidth,
    imageContainerSize.containerHeight,
  );
  return pdpData?.content?.image?.mainImage ? (
    <>
      <ImageComponent
        srcFile={imagePath}
        className={`${getTernaryValue(isMobile, PDP_PRODUCT_MOBILE_IMG, PDP_PRODUCT_IMG)}`}
      />
    </>
  ) : (
    <></>
  );
};

export const resetPayload = (
  pdpData,
  prodQuantity,
  currencyConversionFactor,
  PDP_PAYLOAD_DATA,
  userOrderStateDispatch,
  pdpPromoPage,
  storeTimeZone,
  pdpDataForUpdateFoodLine,
  cartData,
) => {
  let payload = createPDPPayload(
    pdpData,
    prodQuantity,
    currencyConversionFactor,
    pdpPromoPage,
    storeTimeZone,
    pdpDataForUpdateFoodLine,
    cartData,
  );
  userOrderStateDispatch({ type: PDP_PAYLOAD_DATA, value: payload });
};

const PlaceholderPDP = () => (
  <div className='pdp-custm-sopac'>
    <div className='modal-body-row product-listing-component'>
      <form className='form'>
        <div className='accordian-container'>
          <div className='accordian-header'>
            <div className='accordion placeholder'>
              <div className='loading card-title shorter-m' />
            </div>
          </div>
        </div>
        <div className='accordian-container'>
          <div className='accordian-header'>
            <div className='accordion placeholder'>
              <div className='loading card-title shorter-m' />
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
);

const getImportPath = (dispositionType, customizable) => {
  const { PDP_CUSTOMIZATION_PAGE, PDP_NON_CUSTOMIZATION_PAGE } = MENU_PDP_PAGE_CONSTANTS;
  const flag = getAndCheck(isCateringDisposition(dispositionType), !customizable) || customizable;
  return getTernaryValue(flag, PDP_CUSTOMIZATION_PAGE, PDP_NON_CUSTOMIZATION_PAGE);
};

const pdpRecommendedItem = (CROSSELL, makeItAComboData, header, tenantData, PDP, productDetails) => {
  return getLength(makeItAComboData) ? (
    <RecommendedContainer
      products={makeItAComboData}
      country={tenantData?.country}
      cssClass='pdp-combo'
      header={header}
      subHeader=''
      recommendedRule={CROSSELL}
      source={PDP}
      categoryId={productDetails.categoryId}
    />
  ) : null;
};
const checkBasketId = (
  parms,
  addtoCartClinckHandler,
  dispatch,
  tenantData,
  userOrderState,
  setAddToClickParms,
  setCouponModal,
) => {
  const {
    event,
    data,
    miniPDPData,
    totalAmount,
    cartId,
    pdpDataForUpdateFoodLine,
    cartData: cartReducerData,
    storesWithStatus,
  } = parms;
  if (cartId && event) {
    const { paymentDiscountLines = [] } = cartReducerData;
    if (paymentDiscountLines?.length) {
      removeCouponHandler({ setCouponModal, parms, setAddToClickParms });
    } else {
      addtoCartClinckHandler(event, data, miniPDPData, cartId, totalAmount, pdpDataForUpdateFoodLine, cartReducerData);
      setAddToClickParms({});
    }
  } else if (!cartId && event) {
    setAddToClickParms(parms);
    createNewBasketId(dispatch, tenantData?.tenantId, userOrderState, storesWithStatus);
  }
};

export const redirectTOPlpPageCheck = (
  cartData,
  redirectionToPlpPage,
  appliedCouponCode,
  history,
  addOnRecommendedData,
) => {
  if (cartData?.discountLines?.length > 0 && addOnRecommendedData.length === 0) {
    return (
      redirectionToPlpPage &&
      cartData?.discountLines.some(item => item.couponCode === appliedCouponCode) &&
      goToMenuPage(history)
    );
  }
};

export const addToCartAnalytic = analyticObjData => {
  const {
    flatResponseData,
    analyticObjectData,
    tenantData,
    couponCode,
    discountTotal,
    isFromRecommendedSectionItemClick,
    isItemAdded,
    userType,
  } = analyticObjData;
  const itemDetail = flatResponseData?.itemMapById?.[analyticObjectData?.id];
  const { name = '', availability, id: itemId, categoryName, categoryId } = getValueOrDefaultObject(itemDetail);
  const availabilityObj = getFirstArrayItem(availability);

  const itemsList = [
    {
      item_name: name,
      item_id: itemId,
      price: getPrice(availabilityObj, tenantData?.currencyConversionFactor),
      coupon: couponCode,
      currency: ANALYTICS_SHARED_CONSTANTS.AUD,
      discount: calculatePrice(discountTotal, tenantData?.currencyConversionFactor),
      item_category: categoryName,
      item_list_name: getTernaryValue(
        isFromRecommendedSectionItemClick,
        ANALYTICS_SHARED_CONSTANTS.PDP_UPSELL,
        categoryName,
      ),
      item_list_id: categoryId,
      index: 1,
      quantity: analyticObjectData?.itemCount,
    },
  ];
  if (
    getCheckIfAnyOnePass(
      isFromRecommendedSectionItemClick,
      isCateringDisposition(localStorage.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_TYPE)),
      isDeliveryDisposition(localStorage.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_TYPE)) ||
        isPickupDisposition(localStorage.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_TYPE)),
    )
  ) {
    RecommendedAnalyticHandler(isItemAdded, analyticObjectData, userType, itemsList);
  }
};

const getProductImageAndSummaryViewTemplate = productImageSummaryData => {
  const {
    pdpData,
    isMobile,
    imageContainerSize,
    isPdpDataLoading,
    pdpbackgroundImageData,
    displayBreadcrumbPDP,
    currentPDPProduct,
    pdpSummaryView,
  } = productImageSummaryData;
  return (
    <div className={`${isMobile ? 'pdp-mobile-image-container-sopac' : 'd-flex'}`}>
      <div
        className={`${isMobile ? 'mobile-background-image-container' : 'image-container'}`}
        style={getBackgroundImageSrc(
          pdpbackgroundImageData,
          imageContainerSize.containerWidth,
          imageContainerSize.containerHeight,
        )}
      >
        {pdpProductImageSopac(pdpData, isMobile, imageContainerSize, isPdpDataLoading)}
      </div>
      {isMobile && <div className='pdp-mobile-navigation'>{breadcrumbtemplate(displayBreadcrumbPDP)}</div>}
      {currentPDPProduct.modgrps && pdpSummaryView()}
    </div>
  );
};
const MenuPdpItem = ({ menuPDPItemData }) => {
  const {
    productDetails,
    tenantData,
    isMobile,
    displayBreadcrumbPDP,
    isIpad,
    product_name,
    isStoreClosed,
    prodName = '',
    prodItems = [],
    showLegalInfo,
    dispositionType,
    prodURL,
    imageContainerSize,
    indulgentImageContainerSize,
    storeTimeZone,
    categoryName,
    categoryUrl,
    catalogs,
    updatedFetchMenuPayload,
  } = menuPDPItemData;
  const { ADD_TO_CART_CLICK, DISPOSITION_DATA } = START_ORDER_CONSTANTS;
  const {
    CUSTM_EXPAND_TYPE,
    CROSSELL,
    PDP,
    IS_IN_STOCK,
    PDP_PAYLOAD_DATA,
    RESET_MODGROUP_IDS_UPDATE,
    RESET_CUSTOMIZATION,
    CUSTOMISE_FLAG_CART,
    SET_PDP_BUTTON_DISABLED,
    SHOW_PDP_ALERT_POPUP,
  } = MENU_PDP_PAGE_CONSTANTS;
  const {
    RECOMMENDED_HEADER_TITLE,
    RECOMMENDED_HEADER_TITLE_CATERING,
    ADD_TO_CART,
    INDULDENT_ADD_ON_MSG,
    INDULDENT_ADD_ONS_HEADING,
    CONTINUE,
  } = TRANSLATE_MAPPING_KEY;
  const [pdpData, setPdpData] = useState({});
  const [modifierGrp, setModifierGroup] = useState();
  const [makeItAComboData, setMakeItAComboData] = useState([]);
  const [recommendationData, setRecommendationData] = useState([]);
  const [currentPDPProduct, setCurrentPDPProduct] = useState({});
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const { headerData: { pdpBackgroundImage = {} } = {} } = useSelector(
    state => state?.marketConfigReducer?.response || {},
  );
  const pdpbackgroundImageData = getBackgroundImagePath(pdpBackgroundImage);
  const { pdpPayloadData, isFromRecommendedSectionItemClick, pdpPromoPage, pdpDataForUpdateFoodLine } = userOrderState;
  const currentItemObject = useSelector(({ menuReducer: { currentItemDetails } }) => currentItemDetails);
  const flatResponseData = useSelector(({ menuReducer: { flatResponse } }) => flatResponse);
  const [quantityRemovedObject, setQuantityRemovedObject] = useState({});
  const [prodQuantity, setProdQuantity] = useState(0);
  const [itemStatus, setItemStatus] = useState(IS_IN_STOCK);
  const [analyticObjectData, setAnalyticObject] = useState({});
  const userParams = useSelector(data => data.appStateReducer.userStatus);
  const { QUANTITY_ACTION, EDIT_ITEM } = CART_PAGE_CONSTANTS;
  const cartReducer = useSelector(data => data.cartReducer);
  const { cartData = {}, isItemAdded = false } = getValueOrDefaultObject(cartReducer);
  const { storesWithStatus } = useSelector(data => data?.storesReducer) || {};
  const dispatch = useDispatch();
  const history = useHistory();
  const showCrossSellSection = tenantData?.componentOptions?.web?.pdp?.showCrossSellSection;
  const redirectionToPlpPage = tenantData?.componentOptions?.web?.pdp?.plpRedirectionPromoItem;
  const cartDataItemval = cartData?.foodLines?.map(food => food?.item?.id);
  const listItem =
    cartData?.foodLines?.length > 0 && recommendationData?.filter(arrval => !cartDataItemval.includes(arrval.id));
  const showRecommendationFilter = tenantData?.componentOptions?.web?.pdp?.shouldFilterRecommendationListWithCartData;
  const getFilterRecommdation =
    showRecommendationFilter && cartData?.foodLines?.length > 0 ? listItem : recommendationData;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const recommendedHeader = useMemo(
    () =>
      checkIfCateringPage(history?.location?.pathname) ? RECOMMENDED_HEADER_TITLE_CATERING : RECOMMENDED_HEADER_TITLE,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [history?.location?.pathname],
  );
  const userType = getUserType(userParams?.localized, userParams?.loggedIn);
  const { couponCode = '', discountTotal = '' } = getCouponDetails(cartData);
  const [addOnRecommendedData, setAddOnRecommendedData] = useState([]);
  const [openIndulgentModal, setOpenIndulgentModal] = useState(false);
  const isPdpDataLoading = useSelector(data => data.menuReducer?.isItemDetailsLoading);
  const [addToClickParms, setAddToClickParms] = useState({});
  const [isItemDecreased, setIsItemDecreased] = useState(false);
  const [ruleName, setRuleName] = useState({});
  const [couponModal, setCouponModal] = useState(false);
  const addOnModalCartBtnClick = JSON.parse(sessionStorage.getItem(SESSION_STORAGE_KEYS.INDULGENT_ADDONS_CART_CLICK));
  const sliceDispatch = useAppDispatch();
  const [appliedCouponCode, setAppliedCouponCode] = useState('');
  useEffect(() => {
    userOrderStateDispatch({ type: CUSTM_EXPAND_TYPE, value: 'single' });
    return () => {
      setPdpData({});
      userOrderStateDispatch({
        type: MENU_PDP_PAGE_CONSTANTS.RECOMMENDED_SECTION_ITEM_CLICK,
        isFromRecommendedSectionItemClick: false,
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    redirectTOPlpPageCheck(cartData, redirectionToPlpPage, appliedCouponCode, history, addOnRecommendedData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData?.discountLines, addOnRecommendedData]);

  useEffect(() => {
    let setPDPDataHandlerObj = {
      productDetails,
      currentItemObject,
      prodURL,
      product_name,
      pdpDataForUpdateFoodLine,
      cartData,
      prodName,
      prodItems,
      pdpPromoPage,
      setPdpData,
      userOrderStateDispatch,
      setMakeItAComboData,
      setRecommendationData,
      setAddOnRecommendedData,
      setCurrentPDPProduct,
      setProdQuantity,
      setRuleName,
    };
    setPDPDataHandler(setPDPDataHandlerObj);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(currentItemObject), productDetails]);

  const quantityUpdate = (item, type, event) => {
    event.preventDefault();
    event.stopPropagation();
    if (type === QUANTITY_ACTION.Decrease && prodQuantity > 1) {
      setProdQuantity(prodQuantity - 1);
      setIsItemDecreased(true);
    }
    if (type === QUANTITY_ACTION.Increase) {
      setProdQuantity(prodQuantity + 1);
      checkForQuantityLimit(prodQuantity, pdpPromoPage, pdpData);
    }
  };
  const addtoCartClinckHandlerWrapper = (
    event,
    data,
    miniPDPData,
    cartId,
    totalAmount,
    pdpDataForUpdateFoodLine,
    cartData,
  ) => {
    event.stopPropagation();
    event.preventDefault();
    const parms = {
      event,
      data,
      miniPDPData,
      cartId,
      totalAmount,
      pdpDataForUpdateFoodLine,
      cartData,
      storesWithStatus,
    };
    checkBasketId(
      parms,
      addtoCartClinckHandler,
      dispatch,
      tenantData,
      userOrderState,
      setAddToClickParms,
      setCouponModal,
    );
  };

  const addtoCartClinckHandler = async (
    event,
    data,
    miniPDPData,
    cartId,
    totalAmount,
    pdpDataForUpdateFoodLine,
    cartData,
  ) => {
    event.preventDefault();
    const catalogName = storesWithStatus?.[0]?.summary?.menu?.catalogs?.[0] || catalogs;
    dispatch(
      fetchMenuAction(
        {
          tenantId: tenantData?.tenantId,
          catalogName,
        },
        updatedFetchMenuPayload,
      ),
    );
    sessionStorage.removeItem(SESSION_STORAGE_KEYS.INDULGENT_ADDONS_CART_CLICK, true);
    if (!userParams.localized) {
      userOrderStateDispatch({ type: DISPOSITION_DATA, value: { showDisposition: true } });
      userOrderStateDispatch({
        type: ADD_TO_CART_CLICK,
        value: {
          addToCart: true,
          productItemId: productDetails?.productId,
          categoryId: productDetails?.categoryId,
          oldProduct: productDetails?.productInfo,
          customizable: productDetails?.customizable,
          catalogs: productDetails?.catalogName,
          fromPdpPage: true,
        },
      });
    } else {
      let payloaddata = getFinalPayload(data);
      let { id, modGrps: modifier_Grp, quantity: itemCount } = payloaddata;
      setAnalyticObject({ id, itemCount, totalAmount });
      if (miniPDPData?.flag !== CUSTOMISE_FLAG_CART) {
        const promoDetails = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.VIEW_PRODUCT));
        const productPromosInStorage = promoDetails?.couponCode;
        setAppliedCouponCode(productPromosInStorage);
        if (productPromosInStorage) {
          dispatch(
            addItemToCartAction(
              {
                params: {
                  basketId: cartData?.id,
                },
                tenantId: tenantData?.tenantId,
              },
              [{ ...payloaddata, isProductPromo: true, categoryName, categoryUrl }],
              () => {
                dispatch(
                  applyCoupon(
                    {
                      basketId: cartData?.id,
                      tenantId: tenantData?.tenantId,
                    },
                    {
                      couponCode: productPromosInStorage,
                    },
                  ),
                );

                localStorage.removeItem(LOCAL_STORAGE_KEYS.VIEW_PRODUCT);
                /** storing coupon code in storage for set coupon apply flag in promos card */
                let couponStoringInStorage = {};
                couponStoringInStorage[productPromosInStorage] = payloaddata;
                localStorage.setItem(LOCAL_STORAGE_KEYS.ADD_TO_ORDER, JSON.stringify(couponStoringInStorage));
                //reset pdpPromoPage state to false for convert promo pdp to normal pdp
                userOrderStateDispatch({
                  type: MENU_PDP_PAGE_CONSTANTS.SET_PDP_PROMO_MODE,
                  value: { pdpPromoPage: false },
                });
                setProdQuantity(getQuantity(pdpPromoPage, pdpData?.id, pdpDataForUpdateFoodLine, cartData));
                sliceDispatch(setPWAstorage({ key: SHOW_PDP_ALERT_POPUP, value: true }));
              },
            ),
          );
          setProdQuantity(getQuantity(pdpPromoPage, pdpData?.id, pdpDataForUpdateFoodLine, cartData));
        } else {
          await dispatch(
            addItemToCartAction(
              {
                params: {
                  basketId: cartId,
                },
                tenantId: tenantData?.tenantId,
              },
              [{ ...payloaddata, categoryName, categoryUrl }],
            ),
          );
          setProdQuantity(1);
        }
        setOpenIndulgentModal(true);
      } else {
        dispatch(
          updateLineitemAction(
            {
              params: {
                basketId: cartId,
                basketLineItemId: miniPDPData?.foodLineId,
              },
              tenantId: tenantData?.tenantId,
            },
            {
              Id: id,
              quantity: itemCount,
              modGrps: modifier_Grp,
              isProductPromo: miniPDPData?.isProductPromo,
              categoryName,
              categoryUrl,
            },
            () => {
              history?.push({
                pathname: ROUTE_URL.CART,
              });
            },
          ),
        );
      }

      window.scrollTo(0, 0);
    }
  };

  useEffect(() => {
    const analyticObjData = {
      flatResponseData,
      analyticObjectData,
      tenantData,
      couponCode,
      discountTotal,
      isFromRecommendedSectionItemClick,
      isItemAdded,
      userType,
    };
    !addOnModalCartBtnClick && addToCartAnalytic(analyticObjData);
  }, [
    flatResponseData,
    analyticObjectData,
    tenantData,
    couponCode,
    discountTotal,
    isFromRecommendedSectionItemClick,
    isItemAdded,
    userType,
    addOnModalCartBtnClick,
  ]);

  useEffect(() => {
    const removeAnalyticObjData = {
      flatResponseData,
      analyticObjectData,
      tenantData,
      couponCode,
      discountTotal,
      isFromRecommendedSectionItemClick,
      isItemAdded,
      userType,
    };
    setQuantityRemovedObject(removeAnalyticObjData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isItemDecreased]);

  const recommendationRulesTemplate = (flag, productList, header, subHeader, cssClass) => (
    <RecommendedContainer
      products={productList}
      country={tenantData?.country}
      cssClass={cssClass}
      header={header}
      subHeader={subHeader}
      recommendedRule={CROSSELL}
      source={PDP}
      categoryId={productDetails.categoryId}
    />
  );
  const getUpdatedModifier = data => {
    const { modifierGrp: mod_grps = {} } = data;
    setModifierGroup(mod_grps);
  };

  const resetIndulgentData = itemToBeRemoved => {
    let filteredRecommendedData = addOnRecommendedData.filter(item => !itemToBeRemoved.includes(item?.id));
    setAddOnRecommendedData(filteredRecommendedData);
    addOnRecommendedData?.length <= 0 && setOpenIndulgentModal(false);
  };
  const handleCloseModal = () => {
    setOpenIndulgentModal(false);
    redirectTOPlpPageCheck(cartData, redirectionToPlpPage, appliedCouponCode, history, []);
  };
  const indulgentModal = () => {
    return (
      <IndulgentAddOn
        isMobile={isMobile}
        openIndulgentModal={openIndulgentModal}
        handleClose={handleCloseModal}
        removeItemCart={false}
        IndulgentData={addOnRecommendedData}
        imageContainerSize={indulgentImageContainerSize}
        modalTitle={INDULDENT_ADD_ONS_HEADING}
        continueButtonText={CONTINUE}
        toastMassage={INDULDENT_ADD_ON_MSG}
        callBackMethod={resetIndulgentData}
        productId={productDetails?.productId}
        ruleNameDetails={ruleName}
        data-testid='indulgetAddon-modal'
        addToCart={ADD_TO_CART}
      />
    );
  };

  const pdpSummaryView = () => {
    return (
      <>
        <ProductSummary
          pdpData={pdpData}
          storeTimeZone={storeTimeZone}
          isMobile={isMobile}
          isIpad={isIpad}
          addtoCartClinckHandler={addtoCartClinckHandlerWrapper}
          customModGrps={modifierGrp}
          categoryId={productDetails.categoryId}
          comboData={makeItAComboData?.length}
          itemStatus={itemStatus}
          prodQuantity={prodQuantity}
          setProdQuantity={setProdQuantity}
          quantityUpdate={quantityUpdate}
          setItemStatus={setItemStatus}
          isItemDecreased={isItemDecreased}
          quantityRemovedObject={quantityRemovedObject}
          isStoreClosed={isStoreClosed}
          imageContainerSize={imageContainerSize}
          pdpbackgroundImageData={pdpbackgroundImageData}
          data-testid='add-to-cart-handler'
        />
      </>
    );
  };

  useEffect(() => {
    let param = {
      pdpData,
      prodQuantity,
      tenantData,
      PDP_PAYLOAD_DATA,
      userOrderStateDispatch,
      pdpPromoPage,
      storeTimeZone,
      pdpDataForUpdateFoodLine,
      cartData,
    };
    checkIfItemUpdated(param);
    removePromoTag(userOrderState.pdpItemUpsizeId, userOrderStateDispatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(pdpData), tenantData.currencyConversionFactor, pdpPromoPage, prodQuantity, storeTimeZone]);

  useEffect(() => {
    checkIfProdQtyUpdate(pdpPayloadData, prodQuantity, pdpData?.id, userOrderStateDispatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prodQuantity, pdpPayloadData]);

  useEffect(() => {
    if (isItemAdded) {
      userOrderStateDispatch({ type: RESET_CUSTOMIZATION });
      userOrderStateDispatch({ type: RESET_MODGROUP_IDS_UPDATE });
      resetPayload(
        pdpData,
        1,
        tenantData.currencyConversionFactor,
        PDP_PAYLOAD_DATA,
        userOrderStateDispatch,
        pdpPromoPage,
        storeTimeZone,
        pdpDataForUpdateFoodLine,
        cartData,
      );
    }
    userOrderStateDispatch({ type: SET_PDP_BUTTON_DISABLED, value: {} });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isItemAdded, pdpData?.catalogName]);

  useEffect(() => {
    checkBasketId(
      { ...addToClickParms, cartId: cartData?.id, cartData, pdpDataForUpdateFoodLine, storesWithStatus },
      addtoCartClinckHandler,
      dispatch,
      tenantData,
      userOrderState,
      setAddToClickParms,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData?.id]);

  const productImageSummaryData = {
    pdpData: pdpData,
    isMobile: isMobile,
    imageContainerSize: imageContainerSize,
    isPdpDataLoading: isPdpDataLoading,
    pdpbackgroundImageData: pdpbackgroundImageData,
    displayBreadcrumbPDP: displayBreadcrumbPDP,
    currentPDPProduct: currentPDPProduct,
    pdpSummaryView: pdpSummaryView,
  };
  return isEmptyObject(pdpData) && isEmptyObject(currentPDPProduct) && isEmptyObject(tenantData) ? (
    <>
      <div className='grid-container'>
        {!isMobile && (
          <div className='pdp-navigation pdp-navigation-sopac' id='pdp-navigation-sopac'>
            {breadcrumbtemplate(displayBreadcrumbPDP)}
          </div>
        )}
        <div className={`${getTernaryValue(isMobile, 'pdp-mobile-container ', 'pdp-details-container-sopac')}`}>
          {getProductImageAndSummaryViewTemplate(productImageSummaryData)}
        </div>
      </div>
      <div style={{ backgroundColor: 'white' }}>
        <div className='grid-container'>
          <div
            data-testid='pdp-desc-container'
            className={`pdp-desc-container-sopac ${getTernaryValue(isMobile, 'mobile', '')}`}
          >
            {!!isEmptyObject(currentPDPProduct) && (
              <div className='d-flex'>
                <ProductDescription
                  longDescription={currentPDPProduct?.content?.longDescription}
                  isMobile={isMobile}
                  dispositionType={dispositionType}
                />
              </div>
            )}
          </div>
          {getAndCheck(Object.prototype.hasOwnProperty.call(pdpPayloadData, 'id'), isStoreClosed !== undefined) && (
            <div
              className={`${MENU_PDP_PAGE_CONSTANTS.PDP_CUSTOM_CONTAINER} ${getAndCheck(isMobile, SOURCE_FLAG_MOBILE)}`}
            >
              <div className='d-flex'>
                {(isPdpDataLoading && <PlaceholderPDP />) || (
                  <LazyLoaderWrapper
                    testId='menu-pdp-customization-container-test'
                    data={currentPDPProduct}
                    isModal={false}
                    showPriceContent={false}
                    isMobile={isMobile}
                    customizable={pdpData.customizable}
                    localized={userParams.localized}
                    isStoreClosed={isStoreClosed}
                    callBackToPDP={getUpdatedModifier}
                    catalog={pdpData.catalogName}
                    categoryId={productDetails.categoryId}
                    importPath={getImportPath(dispositionType, pdpData.customizable)}
                  ></LazyLoaderWrapper>
                )}
              </div>
            </div>
          )}
          <LegalInformationDescription showLegalInfo={showLegalInfo} isMobile={isMobile} />
          {getAndCheck(showCrossSellSection, getFilterRecommdation?.length > 0) &&
            recommendationRulesTemplate(CROSSELL, getFilterRecommdation, recommendedHeader, '', 'pdp-recommendations')}
          {addOnRecommendedData?.length > 0 && (
            <div className='cart-addon-container-desktop pdp-addon-modal'>{indulgentModal()}</div>
          )}
        </div>
      </div>
      {pdpRecommendedItem(
        CROSSELL,
        makeItAComboData,
        translateWithI18Next(recommendedHeader),
        tenantData,
        PDP,
        productDetails,
      )}
      {couponModal && (
        <RemoveGiftCardModal
          addtoCartClinckHandler={addtoCartClinckHandler}
          setCouponModal={setCouponModal}
          setAddToClickParms={setAddToClickParms}
          addToClickParms={addToClickParms}
          flag={EDIT_ITEM}
        />
      )}
    </>
  ) : (
    <div className='d-flex justify-content-center no-results-section'></div>
  );
};

export default MenuPdpItem;
